(function twoNuSupportEntryModule(scope) {
  'use strict';
  const TARGET='#TwoNuSupportChatPanel';
  const PHONES=new Set(['85261414775','61492905299']);
  const CUSTOMER_EMAILS=new Set(['online@2nu.vision']);
  const cleanPhone=value=>String(value||'').replace(/[+()\s-]/g,'');
  const cleanLabel=value=>String(value||'').trim().toLocaleLowerCase().replace(/[\s:：]+/g,'');
  function contactUrl(value,base) {
    let url;try{url=new URL(value,base);}catch{return null;}
    if(url.username||url.password)return null;
    if(url.protocol==='mailto:'){let email;try{email=decodeURIComponent(url.pathname).trim().toLowerCase();}catch{return null;}return CUSTOMER_EMAILS.has(email)?{kind:'customer-email',labelKey:'customer_care_chat'}:null;}
    let phone=null;
    if(['https:','http:'].includes(url.protocol)&&url.hostname==='wa.me')phone=cleanPhone(url.pathname.replace(/^\//,''));
    if(['https:','http:'].includes(url.protocol)&&['api.whatsapp.com','web.whatsapp.com'].includes(url.hostname)&&/^\/send\/?$/.test(url.pathname))phone=cleanPhone(url.searchParams.get('phone'));
    if(url.protocol==='whatsapp:'&&url.hostname==='send')phone=cleanPhone(url.searchParams.get('phone'));
    if(!PHONES.has(phone))return null;
    const topic=String(url.searchParams.get('text')||'').toLowerCase();
    return {kind:'customer-whatsapp',labelKey:topic.includes('tryon')?'tryon_fit_chat':topic.includes('lifetime')?'care_chat':'contact_chat'};
  }
  function supportContactLabel(value,href,base,labels=[]) {
    let url,origin;try{url=new URL(href,base);origin=new URL(base).origin;}catch{return false;}
    if(url.username||url.password||!['https:','http:'].includes(url.protocol)||![origin,'https://2nu.vision','https://2nu-prod.myshopify.com'].includes(url.origin))return false;
    const pathname=url.pathname.replace(/^\/(?:en|zh)(?:-[a-z0-9]+)*(?=\/|$)/i,'').replace(/\/$/,'');
    if(pathname!=='/pages/support'||url.hash)return false;
    return ['Customer Care','Customer Service','Contact Us',...labels].map(cleanLabel).includes(cleanLabel(value));
  }
  if(typeof module==='object'&&module.exports)module.exports={contactUrl,supportContactLabel};
  if(!scope.document)return;
  const doc=scope.document;
  function boot(){
    if(!doc.querySelector('[data-two-nu-glass-dock]')||scope.twoNuSupportEntryReady)return;
    scope.twoNuSupportEntryReady=true;
    let copy={};try{copy=JSON.parse(doc.querySelector('[data-two-nu-contact-copy]')?.textContent||'{}');}catch{}
    const excluded=a=>Boolean(a.closest('[data-support-whatsapp-link],[data-zo-ai-share],share-button,.share-button'));
    function enhance(a){
      if(!a?.matches?.('a[href]')||excluded(a))return;
      const marked=a.hasAttribute('data-two-nu-support-trigger');
      const contact=contactUrl(a.getAttribute('href'),doc.baseURI);
      const labelled=supportContactLabel(a.textContent,a.getAttribute('href'),doc.baseURI,[copy.footer_customer_care,copy.footer_contact].filter(Boolean));
      if(!marked&&!contact&&!labelled)return;
      if(!a.hasAttribute('data-two-nu-support-trigger'))a.setAttribute('data-two-nu-support-trigger','');
      if(a.getAttribute('href')!==TARGET)a.setAttribute('href',TARGET);
      a.removeAttribute('target');a.removeAttribute('download');
      if(a.getAttribute('aria-controls')!=='TwoNuSupportChatPanel')a.setAttribute('aria-controls','TwoNuSupportChatPanel');
      if(a.getAttribute('aria-haspopup')!=='dialog')a.setAttribute('aria-haspopup','dialog');
      if(!a.hasAttribute('data-two-nu-support-routed')){
        // Channel-labelled text changes in place; decorative arrows, image
        // nodes, existing contextual labels and business mailboxes stay intact.
        const label=copy[contact?.labelKey]||copy.contact_chat||'Chat with 2nu';
        const isChannelLabel=value=>/whats\s*app/i.test(value)||(contact?.kind==='customer-email'&&/\be-?mail\b|online@2nu\.vision/i.test(value));
        const walk=doc.createTreeWalker(a,scope.NodeFilter.SHOW_TEXT);let node;
        while((node=walk.nextNode()))if(isChannelLabel(node.nodeValue))node.nodeValue=label;
        const aria=a.getAttribute('aria-label');if(aria&&isChannelLabel(aria))a.setAttribute('aria-label',label);
        a.setAttribute('data-two-nu-support-routed','');
      }
    }
    function mountWhatsApp(){
      const header=doc.querySelector('#TwoNuSupportChatPanel .two-nu-support-chat__header');
      const template=doc.querySelector('[data-two-nu-support-whatsapp-template]');
      if(!header||!template||header.querySelector('[data-support-whatsapp-link]'))return;
      const link=template.content.firstElementChild?.cloneNode(true);
      if(link)header.insertBefore(link,header.querySelector('[data-support-chat-close]'));
    }
    mountWhatsApp();
    function scan(node){if(node.nodeType!==1)return;enhance(node);node.querySelectorAll('a[href]').forEach(enhance);}
    scan(doc.documentElement);
    // This listener only marks the original target; the single dock coordinator
    // owns opening chat. No copied WhatsApp text is sent or stored.
    doc.addEventListener('click',event=>enhance(event.target.closest?.('a[href]')),{capture:true});
    const observer=new MutationObserver(records=>{for(const r of records){if(r.type==='attributes')enhance(r.target);else r.addedNodes.forEach(scan);}mountWhatsApp();});
    observer.observe(doc.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['href']});
    scope.addEventListener('pagehide',event=>{if(!event.persisted)observer.disconnect();});
  }
  doc.addEventListener('shopify:section:load',boot);
  if(doc.readyState==='loading')doc.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})(typeof window==='object'?window:globalThis);
